import styled from 'styled-components';
import { userPanelElementStyles } from '../../../styles/sharedStyles';

export const StyledRoleElement = styled.div`
    ${userPanelElementStyles};
`;
